module.exports = __webpack_public_path__ + "static/img/Reimis-Smith.a302e0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Reimis-Smith.jpg
// module id = AEo4
// module chunks = 0